(() => {
  'use strict';
  if (window.caselixWishlistLoaded) return;
  window.caselixWishlistLoaded = true;
  const config = JSON.parse(document.getElementById('cx-wishlist-config').textContent);
  const t = config.text;
  const key = 'caselix:wishlist:v1';
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const grid = document.querySelector('[data-cx-wishlist-grid]');
  let items = read(), toastTimer, generation = 0;
  function read() {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(data)) return [];
      return data.filter(x => x && typeof x.handle === 'string' && /^[a-z0-9-]+$/.test(x.handle)).slice(0, 200);
    } catch { return []; }
  }
  function persist(next) {
    try { localStorage.setItem(key, JSON.stringify(next)); items = next; update(); return true; }
    catch { toast(t.storage); return false; }
  }
  function toast(message) {
    const el = document.getElementById('cx-wishlist-status');
    el.textContent = message; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.hidden = true; }, 4500);
  }
  function node(tag, text, cls) {
    const el = document.createElement(tag);
    if (text) el.textContent = text;
    if (cls) el.className = cls;
    return el;
  }
  function productURL(handle, variant) {
    return root + 'products/' + encodeURIComponent(handle) + (variant ? '?variant=' + encodeURIComponent(variant) : '');
  }
  function update() {
    document.querySelectorAll('[data-cx-save]').forEach(button => {
      const saved = items.some(x => x.handle === button.dataset.handle);
      const label = saved ? t.saved : t.save;
      if (button.getAttribute('aria-pressed') !== String(saved)) button.setAttribute('aria-pressed', String(saved));
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      const span = button.querySelector('[data-cx-label]');
      if (span && span.textContent !== label) span.textContent = label;
    });
    document.querySelectorAll('[data-cx-count]').forEach(el => {
      const value = String(items.length);
      if (el.textContent !== value) el.textContent = value;
      el.hidden = items.length === 0;
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cx-save]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const handle = button.dataset.handle;
    if (!/^[a-z0-9-]+$/.test(handle)) return;
    const exists = items.some(x => x.handle === handle);
    if (exists) { if (persist(items.filter(x => x.handle !== handle))) toast(t.removed); return; }
    const form = button.closest('form[action*="/cart/add"]');
    const input = form && form.querySelector('[name="id"]');
    const variant = input && !input.disabled && /^\d+$/.test(input.value) ? input.value : null;
    if (persist([...items, {handle, title:button.dataset.title, image:button.dataset.image, variant}].slice(-200))) toast(t.saved);
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { items = read(); update(); render(); } });
  const observer = new MutationObserver(update);
  observer.observe(document.body, {childList:true, subtree:true});
  function remove(handle) {
    if (persist(items.filter(x => x.handle !== handle))) { toast(t.removed); render(); }
  }
  async function render() {
    if (!grid) return;
    const current = ++generation;
    grid.replaceChildren();
    if (!items.length) {
      const empty = node('div', '', 'cx-empty');
      empty.append(node('p', t.empty));
      const browse = node('a', t.browse, 'cx-wishlist__button'); browse.href = root + 'collections/best-sellers';
      empty.append(browse); grid.append(empty); return;
    }
    const snapshot = [...items].reverse();
    for (const saved of snapshot) {
      const card = node('article', '', 'cx-wishlist__card');
      card.dataset.handle = saved.handle;
      const link = node('a'); link.href = productURL(saved.handle, saved.variant);
      const heading = node('h2', saved.title || saved.handle); link.append(heading); card.append(link);
      const status = node('p', t.loading); card.append(status);
      const removeButton = node('button', t.remove, 'cx-remove'); removeButton.type = 'button';
      removeButton.setAttribute('aria-label', t.remove + ': ' + (saved.title || saved.handle));
      removeButton.addEventListener('click', () => remove(saved.handle));
      card.append(removeButton); grid.append(card);
      loadCard(saved, card, link, status, removeButton, current);
    }
  }
  async function loadCard(saved, card, link, status, removeButton, current) {
    try {
      const response = await fetch(root + 'products/' + encodeURIComponent(saved.handle) + '.js', {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error(t.unavailable);
      const product = await response.json();
      if (current !== generation || !card.isConnected) return;
      status.remove();
      link.querySelector('h2').textContent = product.title;
      if (product.featured_image) {
        const img = node('img');
        const imageURL = new URL(product.featured_image, location.origin);
        if (imageURL.protocol === 'https:') { imageURL.searchParams.set('width','600'); img.src = imageURL.href; img.alt = product.title; img.width=600; img.height=600; img.loading='lazy'; card.prepend(img); }
      }
      const price = node('p'); card.insertBefore(price, removeButton);
      const formatter = new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency});
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const personalize = /personaliz|custom|engraved|monogram|photo|collage/i.test([product.title, product.type, ...(product.tags || [])].join(' '));
      const view = node('a', personalize ? t.personalize : t.view, 'cx-product-link'); view.href=link.href; card.insertBefore(view, removeButton);
      if (personalize || variants.length >= 250 || !variants.length) {price.textContent=formatter.format(product.price/100); return;}
      const selectLabel = node('label', t.choose);
      const select = node('select'); select.setAttribute('aria-label', t.choose + ': ' + product.title);
      const placeholder = node('option', t.choose); placeholder.value=''; select.append(placeholder);
      for (const variant of variants) {
        const option = node('option', variant.title + ' — ' + formatter.format(variant.price/100) + (variant.available ? '' : ' · ' + t.unavailable));
        option.value=String(variant.id); option.disabled=!variant.available; select.append(option);
      }
      const initial = variants.find(v => String(v.id) === String(saved.variant));
      if (initial) select.value=String(initial.id);
      else if (variants.length===1) select.value=String(variants[0].id);
      selectLabel.append(select); selectLabel.style.flexDirection='column'; card.insertBefore(selectLabel, removeButton);
      const confirm = node('label'); const checkbox = node('input'); checkbox.type='checkbox'; confirm.append(checkbox,node('span',t.confirm)); card.insertBefore(confirm,removeButton);
      const add = node('button',t.add); add.type='button'; card.insertBefore(add,removeButton);
      function selection() {return variants.find(v => String(v.id)===select.value);}
      function changed() {
        const chosen=selection(); price.textContent=formatter.format((chosen ? chosen.price : product.price)/100);
        add.disabled=!(chosen && chosen.available && checkbox.checked);
        link.href=productURL(saved.handle,chosen?.id); view.href=link.href;
      }
      select.addEventListener('change',()=>{
        checkbox.checked=false; changed();
        const chosen=selection(); if(chosen) persist(items.map(item=>item.handle===saved.handle?{...item,variant:String(chosen.id)}:item));
      });
      checkbox.addEventListener('change',changed); changed();
      add.addEventListener('click',async()=>{
        const chosen=selection(); if(!chosen || !chosen.available || !checkbox.checked) return;
        add.disabled=true; select.disabled=true; checkbox.disabled=true; add.textContent=t.adding;
        try {
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:chosen.id,quantity:1}]})});
          const result=await response.json(); if(!response.ok) throw new Error(result.description || t.error);
          toast(t.added); location.assign(root+'cart');
        } catch(error) {toast(error.message || t.error); select.disabled=false; checkbox.disabled=false; add.textContent=t.add; changed();}
      });
    } catch(error) {
      if(current!==generation || !card.isConnected) return;
      status.textContent=error.message || t.error;
      const retry=node('button',t.retry); retry.type='button';
      retry.addEventListener('click',()=>{retry.remove();status.textContent=t.loading;loadCard(saved,card,link,status,removeButton,current);});
      card.insertBefore(retry,removeButton);
    }
  }
  update(); render();
})();
